module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden setting-component",
    attrs: {
      "id": "setting-component"
    }
  }, [_c('dialog-drag', {
    staticClass: "dialog-setting",
    attrs: {
      "id": "dialog-setting",
      "title": _vm.$t('modal.setting.title'),
      "options": _vm.settingModalPos
    }
  }, [_c('ul', {
    staticClass: "cards dialog-setting-cards"
  }, [_c('li', {
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openLayers
    }
  }, [_c('div', {
    staticClass: "card__image card__image--layers dialog-setting-card__image dialog-setting-card__image--layers"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.layers')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedLayers),
      expression: "!openedLayers"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedLayers),
      expression: "openedLayers"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedLayers),
      expression: "openedLayers"
    }],
    staticClass: "cards dialog-layers-cards",
    attrs: {
      "id": "dialog-layers"
    }
  }, [_c('li', {
    staticClass: "cards__item dialog-layers-cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('first')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--fence dialog-layers-card__image dialog-layers-card__image--fence"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title "
  }, [_vm._v(_vm._s(_vm.$t('labels.Foreground')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('move')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--river dialog-layers-card__image dialog-layers-card__image--river"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.advance_more')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('last')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--record dialog-layers-card__image dialog-layers-card__image--record"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.background')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('back')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--flowers dialog-layers-card__image dialog-layers-card__image--flowers"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.Recede_less')))])])])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('animate_components_action'),
      expression: "'animate_components_action'"
    }],
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openAnimation
    }
  }, [_c('div', {
    staticClass: "card__image card__image--effects dialog-setting-card__image dialog-setting-card__image--effects"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.effects')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedAnimation),
      expression: "!openedAnimation"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-animation-cards",
    attrs: {
      "id": "dialog-animation"
    }
  }, [_c('li', {
    staticClass: "cards__item",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'none'
    },
    staticStyle: {
      "padding": "38px"
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('none')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('modal.setting.animation.without_animation')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'grow'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('grow')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image"
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "50",
      "y1": "50",
      "x2": "5.3714",
      "y2": "50"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#E7EAED"
    },
    attrs: {
      "offset": "0.1603"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.5137"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#ACD1EF"
    },
    attrs: {
      "offset": "0.7115"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#C1DAEE"
    },
    attrs: {
      "offset": "0.7853"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#CEDFEE"
    },
    attrs: {
      "offset": "0.8205"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E7EAED"
    },
    attrs: {
      "offset": "0.8654"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M114.203,5.367H89.5h-49H15.797c-5.555,0-10.058,4.503-10.058,10.058v69.15\n\tc0,5.555,4.503,10.058,10.058,10.058H40.5h49h24.703c5.555,0,10.058-4.503,10.058-10.058v-69.15\n\tC124.261,9.87,119.758,5.367,114.203,5.367z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "split-right",
    attrs: {
      "fill": "#01527F"
    }
  }, [_c('path', {
    attrs: {
      "d": "M114.239 49.999c0-.194-.075-.365-.224-.515l-10.438-10.438c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L110.229 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.49 49.999c0-.194-.075-.365-.224-.515L95.828 39.045c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L102.48 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.774 49.999c0-.194-.075-.365-.224-.515L87.112 39.046c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L93.764 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "split-left",
    attrs: {
      "fill": "#01527F"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.256 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L24.266 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L20.481 49.484c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.005 50.001c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L32.015 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L28.23 49.484c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.721 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L40.731 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L36.946 49.484c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.grow')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-in'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-in')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "-843.86",
      "x2": "-735.14",
      "y1": "-1765.76",
      "y2": "-1765.76",
      "gradientTransform": "translate(869.97 1815.33)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".15",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".28",
      "stop-color": "#eaeced"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".38",
      "stop-color": "#e0e8ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".47",
      "stop-color": "#d0e1ee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".55",
      "stop-color": "#b9d7ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".63",
      "stop-color": "#9ccbf0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#95c8f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#92c7f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".76",
      "stop-color": "#8ac3f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".79",
      "stop-color": "#7bbdf1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".82",
      "stop-color": "#65b3f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".85",
      "stop-color": "#4aa8f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".86",
      "stop-color": "#42a4f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M124.75 84.1c0 5.54-4.5 10.04-10.04 10.04H16.44c-5.54 0-10.04-4.5-10.04-10.04V15.04C6.4 9.5 10.9 5 16.44 5h98.27c5.55 0 10.04 4.5 10.04 10.04V84.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M57.915 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L58.14 49.076c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M65.664 49.593c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65.889 49.076c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M74.38 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L74.605 49.076c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-in')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-up'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-up')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image  "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-5737.2393",
      "y1": "-2156.1602",
      "x2": "-5737.2393",
      "y2": "-2245.2402",
      "gradientTransform": "matrix(1 0 0 1 5802.2344 2236.4221)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#EDEDED"
    },
    attrs: {
      "offset": "0.3976"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E9EBED"
    },
    attrs: {
      "offset": "0.4897"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#DFE7ED"
    },
    attrs: {
      "offset": "0.5724"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#CCDFEE"
    },
    attrs: {
      "offset": "0.6514"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#B2D4EF"
    },
    attrs: {
      "offset": "0.7282"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#91C6F0"
    },
    attrs: {
      "offset": "0.8034"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#68B4F1"
    },
    attrs: {
      "offset": "0.8774"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#39A0F2"
    },
    attrs: {
      "offset": "0.9491"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M124.132,85.057c0,5.543-4.494,10.037-10.037,10.037H15.895c-5.544,0-10.037-4.494-10.037-10.037\n\tl0-69.006c0-5.543,4.494-10.037,10.037-10.037h98.201c5.543,0,10.037,4.494,10.037,10.037V85.057L124.132,85.057z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path3_x3E__1_",
      "fill": "#01527F",
      "d": "M64.999,13.917c-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377\n\tc-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.328-0.067,0.463-0.201L65,17.519l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.33-0.067,0.463-0.201\n\tl1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,13.984,65.173,13.917,64.999,13.917z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path2_x3E_",
      "opacity": "0.9",
      "fill": "#01527F",
      "enable-background": "new    ",
      "d": "M64.999,20.878\n\tc-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007\n\tc0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,24.48l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,20.945,65.173,20.878,64.999,20.878z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path1_x3E__2_",
      "opacity": "0.6",
      "fill": "#01527F",
      "enable-background": "new    ",
      "d": "M64.999,28.708\n\tc-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007\n\tc0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,32.31l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,28.775,65.173,28.708,64.999,28.708z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_2_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-2475.406",
      "y1": "-1137.0306",
      "x2": "-2475.406",
      "y2": "-1184.0306",
      "gradientTransform": "matrix(-1 0 0 1 -2410.4109 1232.1246)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_2_)",
      "d": "M5.968,86.093v-27.41c0-5.55,4.614-10.589,10.154-10.589h36.846v6.199\n\tc0,3.13,2.314,4.801,5.444,4.801h13.36c3.13,0,5.196-1.671,5.196-4.801v-6.199h37.094c5.54,0,9.906,5.039,9.906,10.589v27.411h0.054\n\tc-0.6,5-4.83,9-9.96,9h-97.94c-5.13,0-9.36-4-9.96-9L5.968,86.093L5.968,86.093z"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-up')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-down'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-down')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "-1887.4",
      "x2": "-1887.4",
      "y1": "1251.16",
      "y2": "1340.24",
      "gradientTransform": "matrix(-1 0 0 1 -1822.43 -1230.31)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".49",
      "stop-color": "#e9ebed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".57",
      "stop-color": "#dfe7ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#ccdfee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".73",
      "stop-color": "#b2d4ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#91c6f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".88",
      "stop-color": "#68b4f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".95",
      "stop-color": "#39a0f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M5.83 16.05c0-5.54 4.5-10.04 10.04-10.04h98.2c5.54 0 10.03 4.5 10.03 10.04v69c0 5.55-4.49 10.04-10.03 10.04h-98.2c-5.55 0-10.04-4.49-10.04-10.03v-69z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "b",
      "x1": "64.87",
      "x2": "64.87",
      "y1": "6.32",
      "y2": "53.32",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#b)",
      "d": "M123.8 15.31V42.2c0 5.55-4.29 11.13-9.83 11.13H76.81v-6.74c0-3.13-2-4.26-5.13-4.26H58.32c-3.13 0-5.51 1.13-5.51 4.26v6.74H16.03c-5.54 0-10.22-5.58-10.22-11.13V15.31h.26c.6-5 4.83-9 9.96-9h97.94c5.13 0 9.36 4 9.96 9h-.12z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.002 86.191c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.001 78.442c.194 0 .365-.075.515-.224L75.955 67.78c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65 74.432l-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.002 69.726c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z",
      "opacity": ".6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-down')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-left'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-left')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "1093.7883",
      "y1": "1849.1655",
      "x2": "1212.7463",
      "y2": "1849.1655",
      "gradientTransform": "matrix(-1 0 0 1 1196.7474 -1800.0706)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#EDEDED"
    },
    attrs: {
      "offset": "0.1476"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#EAECED"
    },
    attrs: {
      "offset": "0.2811"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E0E8ED"
    },
    attrs: {
      "offset": "0.3813"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#D0E1EE"
    },
    attrs: {
      "offset": "0.4706"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#B9D7EF"
    },
    attrs: {
      "offset": "0.5536"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#9CCBF0"
    },
    attrs: {
      "offset": "0.6315"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#95C8F0"
    },
    attrs: {
      "offset": "0.6483"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#92C7F0"
    },
    attrs: {
      "offset": "0.7129"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#8AC3F0"
    },
    attrs: {
      "offset": "0.7553"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#7BBDF1"
    },
    attrs: {
      "offset": "0.7911"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#65B3F1"
    },
    attrs: {
      "offset": "0.8235"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#4AA8F2"
    },
    attrs: {
      "offset": "0.8531"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#42A4F2"
    },
    attrs: {
      "offset": "0.8609"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M3.808,14.392c0-5.576,4.52-10.095,10.095-10.095h98.768c5.576,0,10.095,4.52,10.095,10.095v69.405\n\tc0,5.575-4.52,10.095-10.095,10.095H13.903c-5.576,0-10.095-4.52-10.095-10.095V14.392L3.808,14.392z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_2_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-1766.7854",
      "y1": "-1182.8807",
      "x2": "-1706.7854",
      "y2": "-1182.8807",
      "gradientTransform": "matrix(1 0 0 -1 1829.9474 -1133.5135)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_2_)",
      "d": "M123.162,14.431v70.033c0,4.895-3.669,8.831-8.257,9.815c-0.691,0.152-1.636,0.079-2.372,0.079H72.58\n\tc-5.322,0-8.418-3.798-9.418-9.024V61.358h5.185c3.184,0,6.815-1.708,6.815-4.895V42.779c0-3.187-3.631-6.421-6.815-6.421h-5.185\n\tV13.561c1-5.226,4.096-9.203,9.42-9.203h39.95c0.737,0,1.678,0.017,2.37,0.169C119.49,5.51,123.162,9.533,123.162,14.431z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M29.911 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L30.136 48.576c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M37.66 49.093c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L37.885 48.576c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M46.376 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L46.601 48.576c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_3_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-45.826",
      "y1": "74.554",
      "x2": "-45.826",
      "y2": "74.554",
      "gradientTransform": "matrix(-1 0 0 1 67.93 15.2735)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_3_)",
      "d": "M113.756,89.827"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-left')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-right'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-right')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "1152.83",
      "x2": "1271.79",
      "y1": "-1765.77",
      "y2": "-1765.77",
      "gradientTransform": "translate(-1128.82 1815.34)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".15",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".28",
      "stop-color": "#eaeced"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".38",
      "stop-color": "#e0e8ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".47",
      "stop-color": "#d0e1ee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".55",
      "stop-color": "#b9d7ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".63",
      "stop-color": "#9ccbf0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#95c8f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#92c7f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".76",
      "stop-color": "#8ac3f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".79",
      "stop-color": "#7bbdf1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".82",
      "stop-color": "#65b3f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".85",
      "stop-color": "#4aa8f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".86",
      "stop-color": "#42a4f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M123.16 84.28a10.1 10.1 0 0 1-10.1 10.1H14.3a10.1 10.1 0 0 1-10.1-10.1v-69.4a10.1 10.1 0 0 1 10.1-10.1h98.77a10.1 10.1 0 0 1 10.1 10.1v69.4z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "b",
      "x1": "-996.83",
      "x2": "-936.83",
      "y1": "1760.48",
      "y2": "1760.48",
      "gradientTransform": "rotate(180 -466.5 904.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#b)",
      "d": "M3.8 84.24V14.21c0-4.9 3.68-8.83 8.27-9.82.69-.15 1.63-.07 2.37-.07h39.95c5.32 0 8.42 3.8 9.42 9.02v23.98h-5.19c-3.18 0-6.81 1.7-6.81 4.89v13.68c0 3.2 3.63 6.42 6.81 6.42h5.19v22.8c-1 5.23-4.1 9.2-9.42 9.2H14.44c-.74 0-1.68-.01-2.37-.16-4.59-.99-8.26-5.01-8.26-9.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M97.705 49.549c0-.194-.075-.365-.224-.515L87.043 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224L97.48 50.066c.15-.153.225-.323.225-.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M89.956 49.549c0-.194-.075-.365-.224-.515L79.294 38.595c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.804-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M81.24 49.549c0-.194-.075-.365-.224-.515L70.578 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "c",
      "x1": "13.21",
      "x2": "13.21",
      "y1": "8.85",
      "y2": "8.85",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-right')))])])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-animation-duration-cards",
    attrs: {
      "id": "dialog-animation-duration"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delayValue),
      expression: "delayValue"
    }],
    staticClass: "form-group delay-element",
    attrs: {
      "id": "delay-element",
      "placeholder": _vm.$t('modal.setting.delay')
    },
    domProps: {
      "value": (_vm.delayValue)
    },
    on: {
      "change": function($event) {
        return _vm.setDelayElement($event)
      },
      "focus": function($event) {
        return _vm.toggleModalDraggable('false')
      },
      "blur": function($event) {
        return _vm.toggleModalDraggable('true')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delayValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-text-animation-cards",
    attrs: {
      "id": "dialog-text-animation"
    }
  }, [(_vm.isComponentText) ? _c('li', {
    staticClass: "cards__item dialog-text-animation-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-text-animation-card",
    class: {
      selected: _vm.currentAnimation === 'strike'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('strike')
      }
    }
  }, [_c('div', {
    staticClass: "card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
  }, [_c('div', {
    staticClass: "text-animation-preview",
    attrs: {
      "id": "animation-strike"
    }
  }, [_c('span', {
    staticClass: "text-animation-preview__sample text-animation-preview__sample--strike"
  }, [_vm._v("Abc")])])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.strike')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isComponentText) ? _c('li', {
    staticClass: "cards__item dialog-text-animation-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-text-animation-card",
    class: {
      selected: _vm.currentAnimation === 'reveal-text'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('reveal-text')
      }
    }
  }, [_c('div', {
    staticClass: "card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
  }, [_c('div', {
    staticClass: "text-animation-preview",
    attrs: {
      "id": "animation-reveal-text"
    }
  }, [_c('span', {
    staticClass: "text-animation-preview__sample text-animation-preview__sample--reveal"
  }, [_vm._v("Abc")])])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.reveal-text')))])])])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openOpacity
    }
  }, [_c('div', {
    staticClass: "card__image card__image--opacity dialog-setting-card__image dialog-setting-card__image--opacity"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.opacity')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedOpacity),
      expression: "!openedOpacity"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedOpacity),
      expression: "openedOpacity"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedOpacity),
      expression: "openedOpacity"
    }],
    staticClass: "opacity-container",
    attrs: {
      "id": "dialog-opacity",
      "title": _vm.$t('modal.setting.opacity')
    }
  }, [_c('div', {
    staticClass: "opacity-container__range"
  }, [_c('range-slider', {
    staticClass: "slider",
    attrs: {
      "min": "0",
      "max": "100",
      "step": "1"
    },
    on: {
      "input": function($event) {
        return _vm.changeOpacity($event)
      },
      "change": _vm.displayOverlay
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider-value"
  }, [_vm._v(_vm._s(_vm.sliderValue) + "%")])], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-388b34ce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/SettingComponent.vue
// module id = 827
// module chunks = 1 3